// @flow
import * as React from 'react';
import type { MapMarkerProps } from '../types';
import Popover from 'react-popover';
import { scroller } from 'react-scroll';

import './index.scss';

const MapMarker = (props: MapMarkerProps) => {
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const { venue } = props;

  const popoverBody = (
    <React.Fragment>
      <h3>{venue.title}</h3>
      <p>
        {venue.address_street} &mdash; {venue.address_city}
      </p>
      <p>
        <a
          href={`http://maps.google.com/maps?q=${venue.title}%20${venue.address_street},${venue.address_city}`}
          title="Go to Google Maps"
          className="gmaps-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fas fa-map-marked-alt"></i>
          <span>Directions</span>
        </a>
      </p>
      {venue.website && (
        <a
          className="website-link"
          href={venue.website}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Website
        </a>
      )}
      {venue.phone && (
        <a className="telephone-link" href={`tel:${venue.phone}`}>
          {venue.phone}
        </a>
      )}
    </React.Fragment>
  );

  const openPopup = () => {
    props.onMarkerClick({
      lat: venue.latitude,
      lng: venue.longitude,
    });
    setPopoverOpen(true);
    // US47976_modifiche_mappa: rimosso perche' al drag si devono aggiornare
    // le venue in base alla posizione corrente. Al click la venue e'
    // sempre prima ora e lo scroll e' conflittuale.
    // scroller.scrollTo(`${venue.latitude}${venue.longitude}`, {
    //   duration: 300,
    //   delay: 500,
    //   smooth: 'easeInQuad',
    //   containerId: 'venues-list',
    //   isDynamic: true,
    // });
  };

  const closePopup = () => {
    props.onMarkerClick(null);
    setPopoverOpen(false);
  };
  return (
    <div className="map-marker">
      <Popover
        isOpen={popoverOpen}
        preferPlace="start"
        onOuterAction={closePopup}
        body={popoverBody}
        tipSize={14}
      >
        <button
          className="map-marker-button"
          title={venue.title}
          onClick={openPopup}
        >
          <img
            src={`++plone++qubicaamf-hyperbowling-resources.static/${
              venue.military ? 'military.png' : 'marker.png'
            }`}
            alt={venue.title}
          />
        </button>
      </Popover>
    </div>
  );
};

export default React.memo<MapMarkerProps>(MapMarker);
